<template>
	<div>
		<UITopHeading>Impressionen</UITopHeading>
		<div v-if="pending" class="py-8 text-center">
			<p>Lade Bilder...</p>
		</div>
		<div v-else-if="error" class="py-8 text-center text-red-500">
			<p>Fehler beim Laden der Bilder</p>
		</div>
		<div
			v-else-if="data && data.length > 0"
			class="container grid grid-cols-1 gap-4 p-4 md:grid-cols-2 lg:grid-cols-3"
		>
			<div
				v-for="(image, index) in data"
				:key="index"
				class="relative overflow-hidden rounded-lg shadow-lg transition-shadow duration-300 hover:shadow-xl"
				:class="{
					'md:col-span-2 lg:col-span-2': index % 7 === 0,
					'lg:row-span-2': index % 11 === 0,
				}"
			>
				<img
					:src="image.url"
					:alt="image.name"
					loading="lazy"
					class="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
					sizes="sm:100vw md:50vw lg:33vw"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
const { data, error, pending } = await useFetch<ImagekitImage[]>(
	'/api/imagekit',
	{
		method: 'GET',
		query: {
			path: '/impressions',
		},
	}
)
</script>

<style></style>
